/**
 * Analytics stub — currently a no-op.
 *
 * Callsites throughout the app use `analytics.track()` to record business
 * events (quote_created, invoice_sent, form_submitted, etc.). Wire this to
 * a real analytics service when one is chosen.
 */

/** Track a custom event — no-op until an analytics service is configured. */
function track(_event: string, _properties?: Record<string, unknown>): void {}

/** Track a page view — no-op. */
function page(_name: string, _properties?: Record<string, unknown>): void {}

/** Identify a user — no-op. */
function identify(_userId: string, _traits?: Record<string, string | number | boolean>): void {}

/** Reset session — no-op. */
function reset(): void {}

export const analytics = { identify, reset, track, page } as const;
